import { axiosService } from "@/services/AxiosService";


/**
 * @typedef {Object} HorseHealthProblem
 * @property {number} id - ID del record del problema di salute
 * @property {number} horse_id - ID del cavallo associato
 * @property {string} health_problem - Descrizione del problema di salute
 * @property {string} date - Data di registrazione del problema di salute
 * @property {string} created - Data di creazione del record
 * @property {string} modified - Data di modifica del record
 * @property {string} diagnosis - Diagnosi del problema di salute
 * @property {string} note - Note aggiuntive sul problema di salute
 */

/**
 * @typedef {Object} HealthProblem
 * @property {number} id - ID del record del problema di salute
 * @property {string} name - Nome del problema di salute
 */


/**
 * Servizio per gestire le informazioni dei cavalli.
 */
class HorsesHealthProblemService {

    abortController = null;

    constructor() {
        this.axiosInstance = axiosService.getInstance(); // Usa l'istanza di AxiosService
    }

    /**
     * 
     * @returns {Promise<HorseHealthProblem>} - 
     * @throws {Error} - 
     */
    async getHorseHealthProblemById(id) {
        try {
            const response = await this.axiosInstance.post('/horse-health-problems/get-horse-health-problem-given-id', {horse_health_problem_id: id});

            if (response.status !== 200) {
                throw new Error('Failed to fetch horse health problem info');
            }

            /** @type {HorseHealthProblem} */
            return response.data.data;
        } catch (error) {
            console.error('Error fetching horse health problem info:', error);
            throw error; // Rialza l'errore per gestirlo nel chiamante
        }
    }

    /**
     * 
     * @returns {Promise<HorseHealthProblem[]>} - 
     * @throws {Error} - 
     */
    async getHorseHealthProblems(page, search = '', params = {}, length = 10) {
        try {
            const response = await this.axiosInstance.post('/horse-health-problems/get-health-problems-given-horse-id', {page, length, search, ...params});

            if (response.status !== 200) {
                throw new Error('Failed to fetch horse health problems info');
            }

            /** @type {HorseHealthProblem[]} */
            return response.data;
        } catch (error) {
            console.error('Error fetching horse health problems info:', error);
            throw error; // Rialza l'errore per gestirlo nel chiamante
        }
    }


    /**
     * 
     * @returns {Promise<HorseHealthProblem>} 
     * @throws {Error} 
     */
    async saveHorseHealthProblem(data) {
        try {
            const formData = new FormData();

            // Separate File objects from horse_images and keep only those with id
            const files = [];
            const imagesWithId = data.horse_health_problem_images.filter(image => {
                if (image.url instanceof File) {
                    files.push(image.url);
                    image.url = null;
                    return false; // Exclude this item from horse_images
                }
                return true; // Keep this item in horse_images
            });

            console.log(imagesWithId);

            // Append all fields in data to FormData individually
            for (const key in data) {
                if (key === 'horse_health_problem_images') {
                // Append the modified horse_images to FormData as a JSON string
                formData.append('horse_health_problem_images', JSON.stringify(data.horse_health_problem_images));
                } else {
                // Append other fields as they are
                formData.append(key, data[key]);
                }
            }

            // Append each File object to FormData under the 'files' field
            files.forEach((file, index) => {
                formData.append(`files[${index}]`, file);
            });
            const response = await this.axiosInstance.post('/horse-health-problems/save-horse-health-problem', formData, {
                headers: {
                  'Content-Type': 'multipart/form-data',
                },
              });

            if (response.status !== 200) {
                throw new Error('Failed to save horse data');
            }

            /** @type {HorseHealthProblem} */
            return response.data.data.result;
        } catch (error) {
            console.error('Error saving horse:', error);
            throw error; // Rialza l'errore per gestirlo nel chiamante
        }
    }

     /**
     * 
     * @returns {Promise<HealthProblem[]>} - 
     * @throws {Error} - 
     */
     async getHealthProblems(page = 1) {
        try {
            const response = await this.axiosInstance.post('/health-problems/get-health-problems', {page});

            if (response.status !== 200) {
                throw new Error('Failed to fetch health problems info');
            }

            /** @type {HealthProblem[]} */
            return response.data.data.health_problems;
        } catch (error) {
            console.error('Error fetching health problems info:', error);
            throw error; // Rialza l'errore per gestirlo nel chiamante
        }
    }

    
}

export const horsesHealthProblemService = new HorsesHealthProblemService();
